import Backbone from 'backbone'
import _ from 'underscore'

import tpl from './template/decoFilter.mustache'
import {
  priceFilterHandler,
  categoryFilterHandler,
} from '../../manager/view.handler'

export var DecoFilterView = Backbone.View.extend({
  tagName: 'div',
  className: 'poker-mall-decoration__filter',
  template: tpl,
  events: {
    'click .poker-mall-filter>a': priceFilterHandler,
    'click .poker-mall-dropdown a': categoryFilterHandler,
  },
  initialize: function (options) {
    if (_.isFunction(options.resetSelected)) {
      this.resetSelected = options.resetSelected
    }
  },
  render: function () {
    var rendered = this.template.render()
    this.$el.empty().append(rendered)
    return this
  },
})
